// AppContext.js
import React, { createContext, useState } from "react";

const ConfigContext = createContext();

const ConfigProvider = ({ children }) => {
  const initialState = {
    // GANGA: {
    //   primaryColor: "",
    //   secondaryColor: "",
    // },
  };

  const [appConfig, setAppConfig] = useState(initialState);

  return (
    <ConfigContext.Provider value={{ appConfig, setAppConfig }}>
      {children}
    </ConfigContext.Provider>
  );
};

export { ConfigContext, ConfigProvider };
